import { render, staticRenderFns } from "./addSuitClass.vue?vue&type=template&id=48f140d2"
import script from "./addSuitClass.vue?vue&type=script&lang=js"
export * from "./addSuitClass.vue?vue&type=script&lang=js"
import style0 from "./addSuitClass.vue?vue&type=style&index=0&id=48f140d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports